import React from 'react';
import { ActivityIndicator, Flex, List, Toast, WhiteSpace, Modal } from 'antd-mobile';
import { findEventWithViewedCounted, findShareConfig } from "../../../services/evt";
import { findAttendees } from "../../../services/attendee";
import { findInvitationBgm } from "../../../services/invitationBgm";
import { signInvitationOpened } from "../../../services/invitation";
import { findPromotes } from "../../../services/promote";
import moment from 'moment';
import { connect } from "react-redux";
import Iconfont from "../../../components/Iconfont/Iconfont";
import TweenOne from 'rc-tween-one';
// import ReactHowler from 'react-howler'
// import ReactPlayer from 'react-player'
import ReactAudioPlayer from 'react-audio-player';
import '@/style/activity.less';
import { weixinShare } from "../../../utils/share";
import Headerfooter from "../Headerfooter";
import OrganizerModal from "../OrganizerModal";
import ShareQrcodeModal from "../ShareQrcodeModal";
import guests from "../../../style/imgs/invitation-page/guests.png";
import head from "../../../style/imgs/invitation-page/head.png";
import HintModal from "../HintModal";
import WxImageViewer from 'react-wx-images-viewer';


const Item = List.Item;
const Brief = Item.Brief;

class MEvent extends React.Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.playerRef = null;
        this.state = {
            ownerName: null,
            ownerMobile: null,
            onPlay: true,
            musicUrl: null,
            btnStatus: null,
            formLoading: false,
            attendeeList: [],
            event: {
                loading: true,
                data: null,
            },

        }
    }

    componentDidMount() {
        if (this.props.location.query.promotecode) {
            sessionStorage.setItem('code', this.props.location.query.promotecode);
            findPromotes({ eventId: this.props.params.id, code: this.props.location.query.promotecode }).then(res => {
                if (res.code == 200) {
                    if (res.data.length > 0) {
                        this.setState({
                            ownerName: res.data[0].ownerName,
                            ownerMobile: res.data[0].ownerMobile,
                            eventName: res.data[0].eventName,
                        })
                    } else {
                        this.props.router.push(`/mobile/cancelactivityresult`);
                    }

                } else {
                    Toast.fail(res.msg, 1);
                    this.props.router.push(`/mobile/cancelactivityresult`);
                }
            }).catch(err => {
                // Toast.fail("访问异常", 1);
            })
        } else {
            sessionStorage.removeItem('code')
        }
        // axios.interceptors.request.use(function (config) {
        //      config.headers.Authorization = '';
        //      return config;
        // },);
        // this.props.fetchEvt(this.props.params.id);

        if (this.props.evt.isFetching) {
            this.fetchEvent(this.props.params.id);
        } else {
            this.setEventData(this.props.evt.data);
        }

        this.fetchMusic();
        if (this.props.location.query.inviteeId) {
            signInvitationOpened(Object.assign({ eventId: this.props.params.id, inviteeId: this.props.location.query.inviteeId })).then()
        }

    }
    //查询活动
    fetchEvent = (id) => {
        findEventWithViewedCounted(Object.assign({ id: id, code: this.props.location.query.promotecode })).then(res => {
            let event = this.state.event;
            if (res.code == 200) {
                this.setEventData(res.data);

            } else {
                Toast.fail(res.msg, 1);
                this.props.router.push(`/mobile/cancelactivityresult`);
            }
        }).catch(err => {
            // Toast.fail("访问异常", 1);
        }).finally(() => {
        })
    }
    //查询参与人列表
    fetchAttendees = (_data) => {
        findAttendees(Object.assign({ eventId: this.props.params.id, status: 'APPROVED', disabled: false, page: 1, pageSize: 5 },
        )).then(res => {
            if (res.code == 200) {
                this.setState({
                    attendeeList: res.data,
                    attendeeTotal: res.total,
                    event: {
                        data: _data,
                        loading: false
                    },
                })

            } else {
                Toast.fail(res.msg, 1);
            }
        }).catch(err => {
            // Toast.fail("访问异常", 1);
        }).finally(() => {
            this.changeFormLoading(false)
        })
    }
    //SETEVENT
    setEventData = (data) => {
        if (data.header.promoteLogo) {
            if (!data.header.showQrCode) {
                data.header.promoteLogo = 'removed';
                data.header.promoteDesc = 'removed';
            }
        }

        document.title = data.header.name;
        //分享
        this.setShareConfig(data);
        //报名按钮状态
        this.setState({
            btnStatus: this.getBtnStatus(data),
        })
        //是否显示名单列表
        !data.config.hideAttendee ?
            this.setState({
                event: {
                    data: data,
                    loading: false
                },
            })
            :
            this.fetchAttendees(data);

    }
    //分享
    setShareConfig = (data) => {
        findShareConfig({ eventId: data.header.id }).then(res => {
            if (res.code == 200) {
                let shareData = {};
                if (res.data) {
                    shareData = {
                        title: res.data.title ? res.data.title : data.header.name,
                        des: res.data.brief ? res.data.brief : `${data.header.beginTime}开始 ${data.header.address}`,
                        img: res.data.image ? res.data.image : (data.header.banner ? data.header.banner : 'https://img.qdj8.cn/event-default.png'),
                    };
                } else {
                    shareData = {
                        title: this.state.eventName ? this.state.eventName : data.header.name,
                        des: `${data.header.beginTime}开始 ${data.header.address}`,
                        img: data.header.banner ? data.header.banner : 'https://img.qdj8.cn/event-default.png',
                    };
                }
                //分享
                weixinShare(shareData, true);
            } else {
                Toast.fail(res.msg, 1);
            }
        }).catch(err => {
            // Toast.fail("访问异常", 1);
        }).finally(() => {
        })

    }
    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }
    //按钮状态
    getBtnStatus = (event) => {
        let status = { disable: false, value: '我要报名' };
        if (!event.header.published) {
            status.disable = true;
            status.value = '未发布';
        } else if (event.header.sellingStatus == 'TOSTART') {
            status.disable = true;
            status.value = '报名未开始';
        } else if (event.header.sellingStatus == 'FINISH') {
            status.disable = true;
            status.value = '报名已结束';
        }
        return status;
    }
    //音乐
    fetchMusic = () => {
        if (this.props.location.query.musicId) {
            findInvitationBgm({ id: this.props.location.query.musicId }).then(res => {
                if (res.code == 200) {
                    this.setState({
                        musicUrl: res.data.url
                    })

                } else {
                    Toast.fail(res.msg, 1);
                }
            })
        }

    }
    //播放暂停
    onPlayFun = () => {
        this.setState({
            onPlay: !this.state.onPlay,
        }, () => {
            if (this.state.onPlay) {
                this.playerRef.audioEl.play();
            } else {
                this.playerRef.audioEl.pause();
            }
        })
    }


    ref = player => {
        let that = this;
        that.playerRef = player;
        window.wx.ready(function () {
            if (that.playerRef) {
                let play = function () {
                    that.playerRef.audioEl.play();
                    document.removeEventListener("touchstart", play, false);
                };
                that.playerRef.audioEl.play();
                document.addEventListener("WeixinJSBridgeReady", function () {
                    play();
                }, false);
                document.addEventListener('YixinJSBridgeReady', function () {
                    play();
                }, false);
                document.addEventListener("touchstart", play, false);
            }
        });


    }

    hideOrganizerModal = () => {
        this.setState({
            organizerVisible: false
        })
    }

    onClose = () => {
        this.setState({
            isOpen: false
        })
    }
    onOpen = (index) => {
        this.setState({
            imgIndex: index
        }, () => {
            this.setState({
                isOpen: true
            })
        })
    }

    render() {

        const { event } = this.state;






        return (
            <div>
                {event.loading ?
                    <ActivityIndicator className='am-loading' animating={event.loading} size="large" text="Loading..." />
                    :
                    <div className="checkin-container" style={{ backgroundColor: '#fff' }}>
                        <Headerfooter type='header' evt={event} />
                        {/* <HintModal visible={event.data.header.promoteLogo ? false : true} /> */}
                        {this.state.musicUrl && <TweenOne
                            animation={{ rotate: 360, repeat: -1, duration: 1300, ease: 'linear' }}
                            paused={!this.state.onPlay}
                            className="music-icon"
                            onClick={() => this.onPlayFun()}
                        >
                            <ReactAudioPlayer
                                // className='react-player'
                                ref={this.ref}
                                autoPlay={true}
                                loop={true}
                                src={this.state.musicUrl}
                                onPlay={val => console.log(val)}
                            // playing={this.state.onPlay}
                            // onReady={()=>{
                            //     this.setState({onPlay:true})
                            // }}
                            />
                        </TweenOne>}

                        <div className="signup-sub-title">
                            活动信息
                            {/* <div
                                onClick={() => this.setState({ shareQrcodeVisible: true })}
                                style={{ float:'right', color: '#959595', background: '#eee', borderRadius: '3px 0 0 3px' }}>
                                <Iconfont style={{ fontSize: 14, }} libname="ckicon" type="fenxiang2" /> 分享
                </div> */}
                        </div>
                        <List className="activity-info">
                            {!event.data.header.freeEvent && <Item extra={<span style={{ color: '#FD7926', fontSize: 12 }}>{event.data.header.freeEvent ? '免费' : '收费'}</span>}>收费类型：
                            </Item>}
                            <Item >活动时间： {moment(event.data.header.beginTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-M-D HH:mm")}
                                ~{moment(event.data.header.endTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-M-D HH:mm")}</Item>
                            {this.state.ownerName ?
                                <Item>
                                    <Flex align={'start'}>
                                        <span style={{ letterSpacing: 4, flexShrink: 0 }}>主办方：</span>
                                        <div>
                                            <p>{this.state.ownerName}</p>
                                        </div>
                                    </Flex>
                                </Item>
                                :
                                (event.data.header.organizers && event.data.header.organizers.length > 0 &&
                                    <Item>
                                        <Flex align={'start'}>
                                            <span style={{ letterSpacing: 4, flexShrink: 0 }}>主办方：</span>
                                            <div>
                                                {event.data.header.organizers.map((o, index) => <p key={index} dangerouslySetInnerHTML={{ __html: o.replace(/,|，|、|;|；/g, "<br/>") }}></p>)}
                                            </div>
                                        </Flex>
                                    </Item>)
                            }
                            {event.data.header.collaborators && event.data.header.collaborators.length != 0 ?
                                <Item>
                                    <Flex align={'start'}>
                                        <span style={{ letterSpacing: 4, flexShrink: 0 }}>协办方：</span>
                                        <div>
                                            {event.data.header.collaborators.map((o, index) => <p key={index} dangerouslySetInnerHTML={{ __html: o.replace(/,|，|、|;|；/g, "<br/>") }}></p>)}
                                        </div>
                                    </Flex>
                                </Item> : ''
                            }
                            {event.data.header.contractors && event.data.header.contractors.length != 0 ?
                                <Item>
                                    <Flex align={'start'}>
                                        <span style={{ letterSpacing: 4, flexShrink: 0 }}>承办方：</span>
                                        <div>
                                            {event.data.header.contractors.map((o, index) => <p key={index} dangerouslySetInnerHTML={{ __html: o.replace(/,|，|、|;|；/g, "<br/>") }}></p>)}
                                        </div>
                                    </Flex>
                                </Item> : ''
                            }
                            {event.data.header.customOrganizer && JSON.parse(event.data.header.customOrganizer).map((obj, index) => (
                                <Item key={index}>
                                    <Flex align={'start'}>
                                        <span style={{ flexShrink: 0, maxWidth: 110 }}>{obj.name}：</span>
                                        <div>
                                            {/* {
                                                obj.value.indexOf(',') > -1 ?
                                                    obj.value.split(',').map((v, vindex) => (<p key={vindex}>{v}</p>))
                                                    :
                                                    obj.value.split('，').map((v, vindex) => (<p key={vindex}>{v}</p>))
                                            } */}
                                            <p dangerouslySetInnerHTML={{ __html: obj.value.replace(/,|，|、|;|；/g, "<br/>") }}>

                                            </p>
                                        </div>
                                    </Flex>
                                </Item>
                            ))}
                            {(event.data.header.contactPhone || this.state.ownerMobile) &&
                                <Item extra={<a href={`tel:${this.state.ownerMobile ? this.state.ownerMobile : event.data.header.contactPhone}`}><Iconfont style={{ fontSize: 20, color: '#1296db' }} libname="ckicon" type="dianhua" /></a>}>联系电话：{this.state.ownerMobile ? this.state.ownerMobile : event.data.header.contactPhone}</Item>}
                            {event.data.header.lng == 0 && event.data.header.lat == 0 ? ''
                                :
                                <Item extra={
                                    <a href={`https://uri.amap.com/navigation?to=${event.data.header.lng},${event.data.header.lat},${event.data.header.address}&&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0`}>
                                        <Iconfont style={{ fontSize: 20, color: '#49c5d3' }} libname="ckicon" type="daohang" />
                                    </a>}>
                                    活动地点：{event.data.header.address}</Item>
                            }
                        </List>
                        {event.data.agenda.length > 0 && <div className="signup-sub-title">活动流程</div>}
                        <List className='activity-agenda'>
                            {event.data.agenda.map((obj, index) => {
                                return <Item key={index} multipleLine><Iconfont style={{ color: '#39C5C1' }} libname="ckicon" type="shijian" /> {obj.date}
                                    <span style={{ marginLeft: 20 }}>
                                        {moment(obj.fromTime, 'HH:mm').format("HH:mm")} ~ {moment(obj.toTime, 'HH:mm').format("HH:mm")}
                                    </span>
                                    <Brief>
                                        <p dangerouslySetInnerHTML={{ __html: obj.content ? obj.content.replace(/\n/g, "<br/>").replace(/\r\n/g, "<br>").replace(/\s/g, "&nbsp;") : '' }}></p>
                                    </Brief>
                                </Item>
                            })}
                        </List>
                        {event.data.guests.length > 0 && <div className="signup-sub-title">活动嘉宾</div>}
                        <List className='activity-guests'>
                            {event.data.guests.map((obj, index) => {
                                return <Flex key={index} justify='start' wrap="wrap" align='start' className='activity-guests-flex'>
                                    <div className='guests-head'>
                                        <img src={obj.avatarUrl ? obj.avatarUrl : guests} alt="" />
                                    </div>
                                    <Item multipleLine >{obj.name}
                                        <Brief>
                                            <p dangerouslySetInnerHTML={{ __html: obj.introduction ? obj.introduction.replace(/\n/g, "<br/>").replace(/\r\n/g, "<br>").replace(/\s/g, "&nbsp;") : '' }}></p>
                                        </Brief>
                                    </Item>
                                </Flex>
                            })}
                        </List>
                        {!event.data.config.hideAttendee ? '' :
                            <div>
                                <div className="signup-sub-title">已报名{this.state.attendeeTotal ? `(${this.state.attendeeTotal})` : ''}</div>
                                <List className='activity-roll'>
                                    <Item extra={this.state.attendeeList.length == 5 ? '...' : ''} multipleLine arrow="horizontal" onClick={() => {
                                        this.state.attendeeList.length > 0 ? this.props.router.push(`/mobile/attendeelist/${event.data.header.id}`) : ''
                                    }}>
                                        {this.state.attendeeList.length == 0 ? <span className='roll-hint'><Iconfont style={{ fontSize: 20, color: '#FD7926' }} libname="ckicon" type="smiling" /> 快报名吧，您是第一人哦！</span> :
                                            this.state.attendeeList.map((obj, index) => {
                                                return <span key={index} className='roll-item'>
                                                    <span ><img src={obj.avatarUrl ? obj.avatarUrl : head} alt="" /></span>
                                                    {obj.form.fields.filter(obj => obj.type == 'TEXT' && obj.name == '姓名').length > 0 && obj.form.fields.filter(obj => obj.type == 'TEXT' && obj.name == '姓名')[0].fills[0]}
                                                    {/*{moment(obj.createTime, "YYYY-MM-DD HH:mm:ss").fromNow()}*/}
                                                </span>
                                            })

                                        }

                                    </Item>
                                </List>
                            </div>

                        }
                        {event.data.config.enableInviteeStatistics &&
                            <List>
                                <WhiteSpace className='qa-whitespace' size="sm" />
                                <Item onClick={() => this.props.router.push(`/mobile/wxshareattendeelist/${event.data.header.id}`)} arrow="horizontal">邀请统计</Item>
                            </List>}
                        {event.data.config.enableComment &&
                            <List>
                                <WhiteSpace className='qa-whitespace' size="sm" />
                                <Item onClick={() => this.props.router.push(`/mobile/commentlist/${event.data.header.id}`)} arrow="horizontal">查看评论</Item>
                            </List>}
                        {event.data.header.summary || event.data.videos.length > 0 || event.data.posters.length > 0 ?
                            <div className="signup-sub-title">活动详情</div> : ''}
                        {event.data.header.summary || event.data.videos.length > 0 || event.data.posters.length > 0 ?
                            <div className='activity-describe'>
                                {
                                    event.data.videos.map((obj, index) => (
                                        <a key={index} href={obj.link} style={{
                                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            height: '10.35rem', background: `url(${obj.cover}) 0% 0% / 100% 100%`, marginBottom: 18
                                        }}>
                                            <div style={{
                                                width: 50, height: 50,
                                                borderRadius: '50px', background: '#fff',
                                                textAlign: 'center', lineHeight: '50px'
                                            }}>
                                                <Iconfont style={{ fontSize: 20, color: '#000' }} libname="ckicon" type="bofang2" />
                                            </div>
                                        </a>
                                    ))
                                }

                                <div className='activity-describe-text' dangerouslySetInnerHTML={{ __html: event.data.header.summary ? event.data.header.summary.replace(/##PageBreak##/g, '').replace(/\n/g, "<br/>").replace(/\r\n/g, "<br/>").replace(/\s/g, "&nbsp;") : '' }}></div>
                                <div className='activity-describe-img'>
                                    {event.data.posters.map((obj, index) => {
                                        return <img onClick={() => this.onOpen(index)} key={index} src={obj.url} alt="" />
                                    })}
                                </div>
                            </div> : ''}

                        {
                            this.state.isOpen && <WxImageViewer zIndex={1000} onClose={this.onClose} urls={event.data.posters.map(o => o.url)} index={this.state.imgIndex} />
                        }



                        <WhiteSpace className='qa-whitespace' size="sm" />
                        <Headerfooter type='footer' evt={event} />
                        {
                            event.data.header.showFeedback &&
                            <div className='qa-whitespace' style={{ textAlign: 'center', fontSize: 12, padding: '10px 0' }}>
                                <a href={`/mobile/inform?eventId=${event.data.header.id}&name=${event.data.header.name}`} style={{ color: '#959595' }}>投 诉</a>
                            </div>
                        }

                        {/*<WhiteSpace className='qa-whitespace' size="lg"/>*/}
                        {/*<div style={{height:49,backgroundColor:'#eee'}}></div>*/}
                        {this.props.location.query.custom == 'oppo' ?
                            <div className='custom-oppo-btn'>
                                <a onClick={() => window.location.href = `/mobile/findvoucher?eventId=${event.data.header.id}&hide=true`}>个人参会信息查询</a>
                            </div>
                            :
                            <div className='activity-signup qa-whitespace'>
                                {!this.props.location.query.hideBar &&
                                    <div className='activity-signup-flex'>
                                        <div className='voucher-btn'>
                                            <a href={`/mobile/findvoucher?eventId=${event.data.header.id}&hide=true`}>
                                                <Iconfont libname="ckicon" type="erweima" />
                                                <span>我的信息</span>
                                            </a>
                                            {event.data.header.contactQrcodeImg ?
                                                <a onClick={() => this.setState({ wxVisible: true })}>
                                                    <Iconfont libname="ckicon" type="dianhua2" />
                                                    <span>主办方</span>
                                                </a>
                                                :
                                                (event.data.header.contactPhone ?
                                                    <a href={`tel:${this.state.ownerMobile ? this.state.ownerMobile : event.data.header.contactPhone}`}>
                                                        <Iconfont libname="ckicon" type="dianhua2" />
                                                        <span>主办方</span>
                                                    </a>
                                                    :
                                                    <a onClick={() => Toast.offline('该主办方很懒，没有留下联系方式', 1)}>
                                                        <Iconfont libname="ckicon" type="dianhua2" />
                                                        <span>主办方</span>
                                                    </a>
                                                )}
                                            <a onClick={() => this.setState({ shareQrcodeVisible: true })} >
                                                <Iconfont libname="ckicon" type="fenxiang2" />
                                                <span>分享</span>
                                            </a>
                                        </div>
                                        <a className='signup-btn'
                                            disabled={this.state.btnStatus.disable}
                                            onClick={() => window.location.href = `/mobile/signup/${event.data.header.id}${this.props.location.search}${this.props.location.search ? '&' : '?'}hide=true`}>{this.state.btnStatus.value}</a>
                                    </div>}
                                {this.state.shareQrcodeVisible &&
                                    <ShareQrcodeModal
                                        evt={event}
                                        hide={() => this.setState({ shareQrcodeVisible: false })}
                                    />}
                            </div>
                        }

                        <Modal
                            visible={this.state.wxVisible}
                            transparent
                            closable={true}
                            maskClosable={true}
                            onClose={(e) => {
                                e.preventDefault();
                                this.setState({ wxVisible: false })
                            }}
                        >
                            <div style={{ paddingTop: 20 }}>
                                <img style={{ width: 180 }} src={event.data.header.contactQrcodeImg} alt="" />
                                <p style={{ color: '#959595', fontSize: 12 }}>
                                    {event.data.header.contactQrcodeText}
                                </p>
                            </div>
                        </Modal>

                    </div>}

                {this.state.organizerVisible &&
                    <OrganizerModal
                        data={event.data.header}
                        hide={this.hideOrganizerModal}
                    />
                }



            </div>
        )
    }
}

MEvent.defaultProps = {
    event: null,

};
const mapStateToPorps = state => {
    const evt = state.evt;
    return { evt };
};
const mapDispatchToProps = dispatch => ({
    //fetchEvtWithViewedCounted: bindActionCreators(fetchEvtWithViewedCounted, dispatch),

});

export default connect(mapStateToPorps, mapDispatchToProps)(MEvent);



// WEBPACK FOOTER //
// ./src/containers/invitation-page/template/MEvent.jsx